<div class="mt-25 pl-20">
    <p>Unimos empresas con necesidad de liquidez con inversionistas que buscan rentabilizar su dinero con nuestros servicios de Factoring y Confirming.</p>
</div>

<div class="container pl-20">
    <div class="content">
        <img class="icon" [src]="'../../../../../assets/artwork/icon-1.svg'">
        <p class="black">100% online y sin tanto papeleo.</p>    
    </div>
</div>